<template>
	<v-dialog :modelValuemas="isSearch"
		width="550">
		<v-card :loading="loading">
			<div :class="$style.wrapper">
				<v-text-field
					v-model="query"
					clearable
					persistent-clear
					hide-details
					color="primary"
					placeholder="Поиск"
					variant="underlined"
					@input="handleInput"
				/>
				<v-list v-if="results.length && queried"
					class="fade-transition">
					<div class="ao-p3-medium mt-3 mb-1">Результаты поиска: </div>
					<div :class="$style.scrollable">
						<v-list-item
							v-for="i in 10"
							color="primary"
							class="rounded mt-1 ao-h4"
							:value="i + '-id'"
						>
							<template v-slot:prepend>
								<ao-icon iconName="mapField"
									class="mr-2"/>
							</template>
							<template v-slot:title>
								<span class="ao-p2-regular">ПК 1 - 348(369)га</span>
							</template>
							<template v-slot:subtitle>
								<span class="ao-p3-medium">Земельный банк: Таблица</span>
							</template>
							<template v-slot:append>
								<div style="font-size: 12px">
									<ao-icon-btn
										class="mr-2"
										iconName="link"
										size="20"
									/>
									<ao-icon-btn
										iconName="newWindow"
										size="20"
									/>
								</div>
							</template>
						</v-list-item>
					</div>
				</v-list>
				<div v-else-if="queried"
					:class="$style.empty">
					<img src="@/assets/images/no-found.png"
						alt="">
					<span class="ao-p1-medium">Результатов не найдено</span>
					<span class="ao-p2-regular">Попробуйте снова</span>
				</div>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
    name: "SearchDialog",

    props: {
        isSearch: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        query: '',

        loading: false,

        queried: false,

        results: [],
    }),

    watch: {
        isSearch(v) {
            if (!v) {
                this.$emit('close')
                this.loading = false
                this.queried = false
                this.results = []
            }
        }
    },
    methods: {
        handleInput() {
            this.loading = true

            setTimeout(() => {
                if (this.query === '123') {
                    this.results = [1, 2, 3]
                }
                this.loading = false
                this.queried = true
                this.$emit('updateQuery', this.query.trim())
            }, 1000)
        }
    }
}
</script>

<style module lang="scss">
.wrapper {
    margin: 2px 24px 24px;
}

.scrollable {
    height: 335px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(15, 24, 34, 0.1);
        border-radius: 4px;
    }
}

.empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 358px;

    img {
        width: 92px;
        height: 92px;
    }
}
</style>
